var count=$('#last_index').val();
var $addRow = $('#add_row');

$addRow.on('click', function(){
  count++;
  $(".reference-form__rows").append(addNewRow(count));
  $('#last_index').val(count);
});

$(document).on('click', '.reference-form__remove-btn', function() {
  $(this).closest('.reference-form__row').remove()
});

function addNewRow(count){
  var newrow='<div class="reference-form__row">'+
    '<div class="reference-form__input">'+
    '<label class="wb-form__label" for="name'+count+'">Prénom et nom</label>'+
    '<input class="wb-form__input" type="text" id="name'+count+'" name="name'+count+'" value="" required>'+
    '</div>'+
    '<div class="reference-form__input">'+
    '<label class="wb-form__label" for="business'+count+'">Entreprise / Organisation</label>'+
    '<input class="wb-form__input" type="text" id="business'+count+'" name="business'+count+'" value="" required>'+
    '</div>'+
    '<div class="reference-form__input">'+
    '<label class="wb-form__label" for="email'+count+'">Courriel</label>'+
    '<input class="wb-form__input" type="email" id="email'+count+'" name="email'+count+'" value="" required>'+
    '</div>'+
    '<div class="reference-form__remove">'+
    '<button class="reference-form__remove-btn wb-button wb-button--small" type="button" title="Supprimer"><i class="far fa-trash-alt"></i></button>'+
    '</div>'+
    '</div>';
  return newrow;
}
